import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { isBotOrLighthouse } from '@/core/utils/botDetection';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCategoryRedirect',
  props: {
    redirectUrl: null,
    isPrivate: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { redirectUrl: string; isPrivate?: boolean }



const modalOpen = ref<boolean>(true);

const hidePopup = ref<boolean>(isBotOrLighthouse());
function doHardRedirect() {
    window.location.href = props.redirectUrl;
}

function buttonAction(redirectCondition: boolean) {
    if (redirectCondition) {
        doHardRedirect();
    } else {
        modalOpen.value = false;
    }
}

return { __sfc: true,props, modalOpen, hidePopup, doHardRedirect, buttonAction }
}

})